module.exports = __webpack_public_path__ + "media/images/deliver-blue-de1927c3ba969daff15914fd7e636b68.svg";